const MOVIMIENTOS = (state, movimientos) => {
    state.movimientos = movimientos;
};



export default {
    MOVIMIENTOS,
};